"use strict";

exports.__esModule = true;
exports.config = void 0;

const config = (brandcode, environment) => ({
  profile: `${brandcode}-${environment}`,
  brandcode,
  environment,
  debugEnabled: {
    type: 'cookie',
    value: '1',
    key: '_mhtc_debug'
  },
  spaModeEnabled: true,
  tagManager: {
    type: 'Gtm',
    gtmid: 'GTM-M3K4J5C',
    environment: 'dev'
  },
  allowedPropertiesForEnrichment: ['transactionstatus'],
  dataLayer: {
    application: 'www',
    brandcode,
    environment,
    type: 'subscriptionshop',
    platform: null,
    pagetype: 'subscriptionshop',
    accessloginshown: false,
    accesswalltype: 'none',
    pagesecure: false,
    pagesecuretype: 'open',
    subscriptiontype: null,
    previouspagetypes: []
  }
});

exports.config = config;